import { render, staticRenderFns } from "./serveDetail.vue?vue&type=template&id=628825a6&scoped=true&"
import script from "./serveDetail.vue?vue&type=script&lang=js&"
export * from "./serveDetail.vue?vue&type=script&lang=js&"
import style0 from "./serveDetail.vue?vue&type=style&index=0&id=628825a6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628825a6",
  null
  
)

export default component.exports